export const radioPop = {
  lunes: [
    {
      startTime: "00:00",
      endTime: "01:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "15:00",
      endTime: "18:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "21:00",
      endTime: "23:59",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          text: "Radio Planeta"
        }
      ],
    }
  ],
  martes: [
    {
      startTime: "09:00",
      endTime: "12:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "14:00",
      endTime: "18:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          /* src: "/assets/audio/ad-4b.mp3", */
          /* at: "07:00", */
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "19:00",
      endTime: "23:59",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          /* at: "07:00", */
          text: "Radio Planeta"
        }
      ],
    }
  ],
  miercoles: [
    {
      startTime: "00:00",
      endTime: "03:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "09:00",
      endTime: "12:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "14:00",
      endTime: "18:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "18:00",
      endTime: "24:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          /* at: "07:00", */
          text: "Radio Planeta"
        }
      ],
    }
  ],
  jueves: [
    {
      startTime: "01:00",
      endTime: "12:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "14:00",
      endTime: "18:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "19:00",
      endTime: "23:30",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "23:30",
      endTime: "23:59",
      title: "ID 2025",
      description: "Break Beat Drops 2025.",
      color: "#c6d406",
      src: "https://dl.dropbox.com/scl/fi/g66tiyv2arfbho4zms6tp/ID-MIX-2025.mp3?rlkey=0kr6f6k4f5izcwjdnuri8mvo0&dl=1",
      cover: "image/radio/id2025.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    }
  ],
  viernes: [
    {
      startTime: "10:00",
      endTime: "15:30",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "21:00",
      endTime: "24:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
  ],
  sabado: [
    {
      startTime: "09:00",
      endTime: "16:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
    {
      startTime: "19:13",
      endTime: "20:30",
      title: "Radio Planeta testt",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8",
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          at: "07:00",
          text: "Radio Planeta"
        }
      ],
    },
  ],
  domingo: [
    {
      startTime: "12:30",
      endTime: "23:00",
      title: "Radio Planeta",
      description: "Perú",
      color: "#e0eb16",
      src: "https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8", /*  https://mdstrm.com/audio/6839e274f40e6b9832e37633/live.m3u8?property=aiir planeta   https://playerservices.streamtheworld.com/api/livestream-redirect/LOS40.mp3 */
      cover: "../image/radio/pop/planeta.jpg",
      voice: [
        {
          /* at: "07:00", */
          text: "Radio Planeta"
        }
      ],
    },
  ]
};